"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.25 3.7a.7.7 0 0 1 .7.7v2.8a.7.7 0 0 1-1.4 0V4.4a.7.7 0 0 1 .7-.7Zm0 8.4a.7.7 0 0 1 .7.7v2.8a.7.7 0 1 1-1.4 0v-2.8a.7.7 0 0 1 .7-.7ZM4.403 3.7a.7.7 0 0 1 .7.7v11.2a.7.7 0 1 1-1.4 0V4.4a.7.7 0 0 1 .7-.7ZM7.5 9.3a.7.7 0 0 0 0 1.4h7.398v2.634a.7.7 0 1 0 1.4 0V6.667a.7.7 0 1 0-1.4 0V9.3H7.5Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PartialOverflowIcon24.js.map